module.exports = __webpack_public_path__ + "img/Paypal provider-screenshot.6565c9a5.png";